import { render, staticRenderFns } from "./MyActiveNotifications.vue?vue&type=template&id=3430f8ab"
import script from "./MyActiveNotifications.vue?vue&type=script&lang=js"
export * from "./MyActiveNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports